import { Const } from '@const/public';
export function getPhotoUrl(photo, size) {
  return "https://".concat(Const.PROJECT_DOMAIN, "/media/").concat(photo.path, "/").concat(size === 'large' ? photo.filename_large : photo.filename_thumb);
}